import * as React from "react";
import isNumber from "lodash/isNumber";
import { useTranslation } from "react-i18next";
import useReportingByAICustomization from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportingByAICustomization";
import { Button } from "components/bootstrap";
import { Icon, HoverForHelp } from "components/common";
import AIReportModal from "security-app/components/Investigations/AIReport/AIReportModal";
import useDisclosure from "util/hooks/useDisclosure";
import useIsInvestigationAIReportEnabled from "security-app/components/Investigations/AIReport/hooks/useIsInvestigationAIReportEnabled";
import useInvestigationReportAvailability from "security-app/components/Investigations/AIReport/hooks/useInvestigationReportAvailability";
const AIReportButton = ({
  investigation,
  small = false,
  bsSize = void 0,
  logsCount,
  eventsCount
}) => {
  var _a;
  const { t } = useTranslation("enterprise_security_investigations");
  const [showAIReportModal, { open: openAIReportModal, close: closeAIReportModal }] = useDisclosure(false);
  const { enabled: enabledForBrand } = useReportingByAICustomization();
  const { data: availability, isLoading: loadingAvailability } = useInvestigationReportAvailability(
    useIsInvestigationAIReportEnabled()
  );
  const hasNoEvidence = isNumber(logsCount) && isNumber(eventsCount) && logsCount + eventsCount === 0;
  const isUnavailable = !loadingAvailability && !availability.available;
  if (!enabledForBrand) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: hasNoEvidence || isUnavailable,
      bsStyle: "primary",
      onClick: openAIReportModal,
      title: t("ai_report_button.generate_title"),
      bsSize: small ? "sm" : bsSize
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "note_add", type: "regular", size: small ? "sm" : void 0 }),
    " ",
    !small && t("ai_report.button"),
    hasNoEvidence && /* @__PURE__ */ React.createElement(HoverForHelp, { title: t("ai_report_button.add_evidence_title") }, t("ai_report_button.add_evidence_text")),
    !hasNoEvidence && isUnavailable && /* @__PURE__ */ React.createElement(HoverForHelp, { title: t("ai_report.unavailable_title") }, (_a = availability.message) != null ? _a : t("ai_report.unavailable_fallback"))
  ), showAIReportModal && /* @__PURE__ */ React.createElement(AIReportModal, { onCancel: closeAIReportModal, investigation }));
};
export default AIReportButton;
